import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import ServiceManager from "../3x1010/services/ServiceManager.js";
import PageDefault from "./PageDefault.js";
import Nav from "../pages/components/Nav.js";
import { parseNormalStringToWords } from "../helpers/helpers.js";

export default class PageSearch extends PageDefault {
  constructor() {
    super();
    this.isHp = false;
    this.localLoader = document.querySelector(".js-local-loader");
    this.data;
    this.main = document.querySelector(".js-main-content-search");
    this.resultsCont = document.querySelector("#js-template-section-results")?.cloneNode(true);
    this.noResultsCont = document.querySelector("#js-template-no-results")?.cloneNode(true);
    // this.btnLoadMore = document.querySelector("#js-template-btn-load-more")?.cloneNode(true);
    this.offset = 3;
    this.idxStart = 0;
    this.idxEnd = this.offset;
    this.currentFilters = [];
    this.filteredData = null;
    this.transition;
    this.timing = 500;
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageSearch - Hello world");

    this.data = $data;
    //const titles = [
    //  "Gioconda",
    //  "Ragazza col turbante",
    //  "Fanciullo con canestro",
    //  "Van Gogh"
    //];
    //const types = [
    //  "primo-piano",
    //  "mezzo-busto",
    //  "figura-intera",
    //  "piano-americano"
    //];
    //this.data = Array.from({ length: 20 }).map((el, i) => {
    //  return {
    //    Titolo: titles[i % titles.length],
    //    Abstract: "Lorem ipsum dolor sit amet...",
    //    PageType: types[i % types.length],
    //    // PageType: "",
    //    Url: "/"
    //  }
    //});
    //this.data.push({
    //  Titolo: "Senza tag",
    //  Abstract: "Lorem ipsum dolor sit amet...",
    //  PageType: "",
    //  Url: "/"
    //});
    //this.data.push({
    //  Titolo: "Con tag nullo",
    //  Abstract: "Lorem ipsum dolor sit amet...",
    //  PageType: null,
    //  Url: "/"
    //});

    this.filteredData = this.data;

    console.log(this.data);

    this.showResults();    

    this.initSearchHeaderForm();

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }
  }

  showResults() {
    if (!this.data) return;
    if (!location.href.includes("?q=")) {
      this.main?.classList.add("search-blank");

      return;
    } 

    this.showLocalLoader(true);

    if (!this.data.length > 0) {
      this.displayNoResults();

    } else {
      this.createFilter();
      this.displayResults();
    }

    window.scrollTo({
      top: this.main.offsetTop - Nav.navHeight,
      left: 0,
      behavior: "smooth"
    });

    this.transition = setTimeout(() => {
      this.showLocalLoader(false);
    }, 1000);
  }

  createFilter() {
    const types = [... new Set(this.data.map(el => el.PageType))]?.filter(t => !Pqp.isNullOrEmpty(t));
    if (!types?.length > 0) return;

    const filterCont = document.querySelector("#js-template-results-filter")?.cloneNode(true);
    if (!filterCont) return;

    filterCont.removeAttribute("id");
    filterCont.addEventListener("click", (e) => filterCont.classList.toggle("is-open"));

    const filterTypes = filterCont.querySelector(".results-filtertypes");
    if (!filterTypes) return;

    types.forEach(t => {
      const type = document.querySelector("#js-template-filtertype")?.cloneNode(true);
      if (!type) return;

      type.removeAttribute("id");
      type.addEventListener("click", this.handleFilterTypeClick.bind(this, t, type));

      const label = type.querySelector(".filter-label");
      if (!label) return;

      const l = parseNormalStringToWords(t);
      label.textContent = l;
      filterTypes.appendChild(type);
    });

    this.main.appendChild(filterCont);
  }

  handleFilterTypeClick(t, type, e) {
    e.stopPropagation();

    type.classList.toggle("is-checked");
    const isChecked = type.classList.contains("is-checked");
    const parent = type.closest(".results-filter-wrap");

    if (!isChecked) {
      this.currentFilters = this.currentFilters.filter(type => type !== t);
      parent?.querySelector(`.filter-chip[data-type="${t}"]`)?.remove();      

    } else {
      if (!this.currentFilters.includes(t)) {
        this.currentFilters.push(t);
        const chip = document.querySelector("#js-template-filter-chip")?.cloneNode(true);
        if (!chip) return;

        chip.removeAttribute("id");
        chip.querySelector(".chip-label").textContent = parseNormalStringToWords(t);
        chip.dataset.type = t;
        chip.addEventListener("click", (e) => {
          e.stopPropagation();
          type.click();
          parent?.classList.remove("is-open");
        });

        parent?.querySelector(".applied-filters").appendChild(chip);
      }
    }

    if (this.currentFilters.length > 0) {
      this.filteredData = this.data.filter(el => this.currentFilters.includes(el.PageType));

    } else {
      this.filteredData = this.data;
    }

    this.idxStart = 0;
    this.idxEnd = this.offset;
    this.renderBtnLoadMore();

    // console.log(this.filteredData, this.idxStart, this.idxEnd);

    this.showLocalLoader(true);

    Array.from(this.main?.querySelectorAll(".search-result"))?.forEach(el => el.remove());
    this.renderCards();

    clearTimeout(this.transition);
    this.transition = setTimeout(() => {
      this.showLocalLoader(false);
    }, 500);
  }

  displayNoResults() {
    if (!this.noResultsCont) return;

    this.noResultsCont.removeAttribute("id");

    const btn = this.noResultsCont.querySelector(".js-btn-try-again");
    const input = document.querySelector(".js-search-header-form input");

    btn?.addEventListener("click", (e) => {
      e.preventDefault();
      input?.focus();

      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });

    this.main?.appendChild(this.noResultsCont);
  }

  displayResults() {
    if (!this.resultsCont) return;

    this.resultsCont.removeAttribute("id");

    this.renderCards();
    if (this.idxEnd < this.filteredData.length) {
      this.renderBtnLoadMore();
    }

    this.main?.appendChild(this.resultsCont);
  }

  renderBtnLoadMore() {
    this.main.querySelector(".btn-load-more")?.remove();

    this.btnLoadMore = document.querySelector("#js-template-btn-load-more")?.cloneNode(true);
    if (!this.btnLoadMore) return;

    this.btnLoadMore.removeAttribute("id");

    this.btnLoadMore.addEventListener("click", (e) => {
      const offset = document.querySelector(`.search-result:last-child`).offsetTop + Nav.navHeight;
      this.renderCards();
      
      window.scrollTo({
        top: offset,
        left: 0,
        behavior: "smooth"
      });
    });

    this.main?.appendChild(this.btnLoadMore);
  }

  renderCards() {
    this.idxEnd >= this.filteredData.length
      && this.btnLoadMore?.remove();

    for (let i = this.idxStart; i < Math.min(this.idxEnd, this.filteredData.length); i++) {
      const entry = document.querySelector("#js-template-search-result")?.cloneNode(true);
      if (!entry) return;

      const el = this.filteredData[i];

      entry.removeAttribute("id");
      entry.href = el.Url;
      entry.dataset.type = el.PageType;

      const type = entry.querySelector(".result-type");
      const title = entry.querySelector(".result-title");
      const desc = entry.querySelector(".result-desc");

      if (type && title && desc) {
        type.textContent = parseNormalStringToWords(el.PageType);
        title.textContent = el.Titolo;
        desc.innerHTML = el.Abstract;
      }

      this.resultsCont.appendChild(entry);
    }

    this.idxStart += this.offset;
    this.idxEnd = Math.min(this.idxEnd + this.offset, this.filteredData.length);

    // console.log(this.idxStart, this.idxEnd);
    // console.log(this.filteredData.slice(this.idxStart, this.idxEnd))    
  }

  showLocalLoader(bool) {
    if (!this.localLoader) return;

    if (!bool) {
      !this.localLoader.classList.contains("is-hidden")
        && this.localLoader.classList.add("is-hidden");

      return;
    }

    this.localLoader.classList.remove("is-hidden");
  }

  initSearchHeaderForm() {
    const sForm = document.querySelector(".js-search-header-form");
    if (!sForm) return;

    const input = sForm.querySelector("input");
    const btn = sForm.querySelector(".js-btn-submit-search");

    if (input && btn) {
      if (input.value.length > 0) {
        btn.classList.remove("is-disabled");
        btn.removeAttribute("disabled");
      }

      input.addEventListener("input", (e) => {
        if (input.value.length === 0) {
          !btn?.classList.contains("is-disabled")
            && btn.classList.add("is-disabled");

          btn.setAttribute("disabled", "");

          return;
        }

        btn.classList.remove("is-disabled");
        btn.removeAttribute("disabled");
      });
    }
  }
}